module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-grid-medium",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-1 uk-width-expand@m"
  }, [_c('div', {
    staticClass: "uk-child-width-1-1 uk-grid-medium",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1 uk-child-width-1-3@s uk-child-width-1-4@m js-list-item-cards",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.page.ShopItems.items), function(Product) {
    return _c('shop-item-block', {
      key: Product.ShopItem.id,
      attrs: {
        "shop-item": Product.ShopItem,
        "shop-item-prices": _vm.page.ShopItemPrices[Product.ShopItem.id],
        "shop-order-item": _vm.page.ShopOrderItems[Product.ShopItem.id]
      },
      on: {
        "buy-shop-item": _vm.buy
      }
    })
  }))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdbf1928","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/SearchResult.vue
// module id = 99
// module chunks = 0